import { getObjectUtil } from 'packages/src'
import { EXERCISES_PATH } from '../../constants'
import { createSelector } from 'reselect'

function getIdsByMuscleExerciseSelector (muscle) {
  return createSelector(state => getObjectUtil(state, EXERCISES_PATH.MUSCLE_TO_IDS),
    (muscleToDomainList) => {
      if (!muscle) {
        return {
          ...(
            muscleToDomainList || {}
          )
        }
      }

      return [
        ...(
          getObjectUtil(muscleToDomainList, `${muscle}.data`) || []
        )
      ]
    }
  )
}

export default getIdsByMuscleExerciseSelector
